<div class="pl-page">

  <!-- The Apps & Plugins hero band (owner 2026-10-12): the title, one line, a chip per group that jumps to it -->
  <header class="pl-hero">
    <div class="pl-hero-inner">
      <h1 class="tools-title">Tools</h1>
      <p class="tools-subtitle">Tools and utilities by Codigrate for designers and developers</p>
      <nav class="pl-chips" aria-label="Tool groups">
        <a *ngFor="let section of sections" class="pl-chip" [attr.href]="'#tools-' + section.key" (click)="jumpTo( section.key, $event )">
          <img *ngIf="section.icon" [src]="section.icon" alt="" width="18" height="18">
          <span>{{ section.title }}</span>
        </a>
      </nav>
    </div>
  </header>

  <!-- every group as the blog's rows (owner 2026-10-12): the group's own short card at the left, its tools' card at
       the right -->
  <section *ngFor="let section of sections" class="tl-row" [id]="'tools-' + section.key" tabindex="-1">
    <header class="tl-head">
      <span class="tl-eyebrow"><img *ngIf="section.icon" class="tl-eyebrow-logo" [src]="section.icon" alt="" width="15" height="15">{{ section.eyebrow }}</span>
      <h2 class="tl-title">{{ section.title }}</h2>
      <p class="tl-lead">{{ section.desc }}</p>
      <ul class="tl-facts">
        <li>{{ section.tools.length }} {{ section.tools.length === 1 ? 'Tool' : 'Tools' }}</li>
        <li>Free In Your Browser</li>
      </ul>
    </header>
    <div class="tl-grid">
      <!-- a tool as the blog's small card (owner 2026-10-12): its icon large in place of a cover, the name, two lines
           of what it does -->
      <a *ngFor="let tool of section.tools" [routerLink]="tool.url" class="tl-card">
        <span class="tl-cover">
          <img [src]="tool.logo" alt="" width="88" height="88" loading="lazy" decoding="async">
        </span>
        <span class="tl-name">{{ tool.name }}</span>
        <span class="tl-desc">{{ line( tool ) }}</span>
      </a>
    </div>
  </section>
</div>
